import MultiSelectDropdown from "../dropdowns/multiSelectDropdown";
import { DataSetResponse } from "../../apiClient";
import useApiClient from "../../hooks/useApiClient";
import {useState} from "react";
import {useDebouncedFunction} from "../../hooks/useDebouncedQueryParams";
import {DEBOUNCE_DELAY} from "../../utils";
import {DROPDOWN_PRELOAD_SIZE} from "../../utils/constants";
import {useQuery} from "@tanstack/react-query";
import {MultiSelectDropdownSmartWrapperProps} from "../dropdowns/types";
import {QUERY_OPTIONS_LOAD_ONCE} from "../../apiUtils";

export const DataSetDropdown = (dropdownProps: MultiSelectDropdownSmartWrapperProps<DataSetResponse, string>) => {
    const api = useApiClient();
    const [debouncedSearchTerm, _setDebounceSearchTerm] = useState("");
    const setDebounceSearchTerm = useDebouncedFunction(
        _setDebounceSearchTerm,
      DEBOUNCE_DELAY
    );

    const mergedApiOptions = {
        size: DROPDOWN_PRELOAD_SIZE,
        query: debouncedSearchTerm || undefined,
    }
    const { data: dataSets, isLoading: dataSetsAreLoading } = useQuery({
      queryKey: ["data-sets", ...Object.entries(mergedApiOptions)],
      queryFn: () => api.dataAccess.listDataSets(mergedApiOptions).then(resp => resp.items),
      ...QUERY_OPTIONS_LOAD_ONCE,
    });
    return (
        <MultiSelectDropdown<DataSetResponse, string>
            label={"Data Sets"}
            options={dataSets ?? []}
            selections={[]}
            isLoading={dropdownProps.isLoading || dataSetsAreLoading}
            renderOption={(o) => o.name}
            onSearchTermChange={setDebounceSearchTerm}
            mapOptionToSelection={o => o.public_id ?? ""}
            {...dropdownProps}
        />
    )
}

export default DataSetDropdown